import { z } from 'zod';

export default z.string().uuid();
